/// <reference path="../../Common/Helpers/GridEditorBase.ts" />

namespace TabAurous.Purchase {
    import fld = PurchaseReturnItemsBOMRow.Fields;

    @Serenity.Decorators.registerClass()
    export class PurchaseReturnItemsBOMEditor extends _Ext.BOMGridEditor<PurchaseReturnItemsBOMRow> { 
        protected getDialogType() { return PurchaseReturnItemsBOMDialog; }
        protected getLocalTextPrefix() { return PurchaseReturnItemsBOMRow.localTextPrefix; } 
        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ rowHeight: 30 });
            
        } 
        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            return buttons;
        }

    }
}